import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Spin from '../../../../components/loading';

import * as reservationActions from '../../../../redux/reservations/actions';
import ENUMS from '../../../../enums';
import { formatter, enumHelper, permissionHelper } from '../../../../utils';
import alertAndConfirmation from '../../../../utils/AlertAndConfirmation';
import ConfirmationModal from '../../../../components/confirmarion-modal/confirmation-modal';
import InvoiceItems from '../invoiceItems';

const {
  WAITING,
  APPROVED,
  AUTO_APPROVED,
  REJECTED,
  CLIENT_DO_NOT_CAME,
} = ENUMS.CAFE_RESERVATION.values;

function ReserveDetails(props) {
  const [confirmationModalVisible, setConfirmationModalVisible] = useState(
    false,
  );
  const [confirmationModalTitle, setConfirmationModalTitle] = useState('');
  const [confirmationModalContent, setConfirmationModalContent] = useState('');
  const [isStartReserveBtnClicked, setIsStartReserveBtnClicked] = useState(
    false,
  );
  const [rejectText, setRejectText] = useState('');
  const [errorClass, setErrorClass] = useState('');

  const {
    loading,
    error,
    editCafeReservationStatusLoading,
    editCafeReservationStatusFailed,
    editCafeReservationStatusError,
    editCafeReservationStatusMessage,
    reservationDetails,

    startReservationLoading,
    startReservationFailed,
    startReservationError,
    startReservationMessage,
  } = props;

  const {
    createdFullName,
    persons,
    status,
    createdAt,
    startAt,
    endAt,
    respondedAt,
    trackingNumber,
    baseCost,
    meal,
    reserveType,
    respondedFullName,
    reservedTables,
    menuItems,
    createdUserMobileNumber,
    cafeBasePrice,
    totalEntranceAmount,
    description,
    reservationFee,
  } = reservationDetails;

  const cafeDiscountDetailsCopy = {
    ...reservationDetails.cafeDiscountDetails,
  };

  const discountCodeDetailsCopy = {
    ...reservationDetails.discountCodeDetails,
  };

  useEffect(() => {
    props.actions.getReserveDetails(props.reserveId);
  }, []);

  const close = () => {
    props.close();
  };

  const handleClientDoNotComeClick = () => {
    setConfirmationModalTitle('اخطار');
    setConfirmationModalContent('آیا از انتخاب عدم مراجعه اطمینان دارید؟');
    setIsStartReserveBtnClicked(false);
    setConfirmationModalVisible(true);
  };

  const clientDoNotCome = () => {
    try {
      const params = { id: props.reserveId };
      props.actions.editReserveStatus(params, CLIENT_DO_NOT_CAME).then(() => {
        alertAndConfirmation({
          type: 'success',
          title: locales('messages.client.do.not.came.after.reserve.started'),
          text: locales('messages.share.of.pre.paid.amount.are.paid.to.cafe'),
        });
        props.close(true);
      });
    } catch (error) {
      console.log(error);
      alertAndConfirmation({
        type: 'error',
        text: error,
        timer: 6000,
      });
      props.close(false);
    } finally {
      setConfirmationModalVisible(false);
    }
    props.close(false);
  };

  const handleStartReserveClick = () => {
    setConfirmationModalTitle('اخطار');
    setConfirmationModalContent('آیا از شروع رزرو اطمینان دارید؟');
    setIsStartReserveBtnClicked(true);
    setConfirmationModalVisible(true);
  };

  const handleWriteReasonReserve = e => {
    setRejectText(e.target.value);
  };

  const startReserve = () => {
    try {
      props.actions.startReserve(props.reserveId).then(() => {
        alertAndConfirmation({
          type: 'success',
          title: locales('messages.reserve.request.was.started'),
          text: locales('messages.you.can.save.customer.invoice'),
        });
        props.close(true);
      });
    } catch (error) {
      console.log(error);
      alertAndConfirmation({
        type: 'error',
        text: error,
      });
      props.close(false);
    } finally {
      setConfirmationModalVisible(false);
    }
  };

  const rejectReserve = () => {
    if (rejectText.length < 1) {
      console.log(locales('errors.messageBodyRequired'));
      setErrorClass('is-invalid');
    } else {
      setErrorClass('');
      const params = {
        id: props.reserveId,
        rejectReason: rejectText,
      };
      try {
        props.actions.editReserveStatus(params, REJECTED).then(() => {
          alertAndConfirmation({
            type: 'success',
            title: locales('messages.reserve.request.was.rejected'),
            text: '',
          });
          props.close(true);
        });
      } catch (error) {
        console.log(error);
        alertAndConfirmation({
          type: 'error',
          text: error,
        });
        props.close(false);
      }
    }
  };

  const approveReserve = () => {
    try {
      const params = { id: props.reserveId };
      props.actions.editReserveStatus(params, APPROVED).then(() => {
        alertAndConfirmation({
          type: 'success',
          title: locales('messages.reserve.request.was.approved'),
          text: locales('messages.confirm.reserve.info.was.send.to.customer'),
        });
        props.close(true);
      });
    } catch (error) {
      console.log(error);
      alertAndConfirmation({
        type: 'error',
        text: error,
      });
      props.close(false);
    }
  };

  const renderButtons = () => {
    const { EDIT_STATUS_RESERVE } = ENUMS.PERMISSIONS.values;

    if (permissionHelper.hasUserPermission(EDIT_STATUS_RESERVE)) {
      switch (status) {
        case WAITING: {
          return (
            <>
              <button
                className={`btn btn-success mx-5`}
                onClick={approveReserve}
                disabled={editCafeReservationStatusLoading}
              >
                {locales('tables.approveReserve')}
              </button>

              <button
                className={`btn btn-danger mx-5`}
                onClick={rejectReserve}
                disabled={editCafeReservationStatusLoading}
              >
                {locales('tables.rejectReserve')}
              </button>
            </>
          );
        }
        case APPROVED:
        case AUTO_APPROVED: {
          return (
            <>
              <button
                className='btn btn-danger mx-5'
                onClick={handleClientDoNotComeClick}
                disabled={startReservationLoading}
              >
                {locales('tables.clientDidNotCome')}
              </button>

              {/* <button
                className='btn btn-success mx-5'
                onClick={handleStartReserveClick}
                disabled={startReservationLoading}
              >
                {locales('tables.startReservation')}
              </button> */}
            </>
          );
        }
      }
    }

    return null;
  };

  return (
    <>
      <Modal isOpen={props.isOpen} size='xl'>
        <ModalHeader>
          <span className='modal-title'>
            {locales('titles.reserve.details')}
          </span>
          <span
            title={locales('labels.close.modal')}
            className='modal-close'
            onClick={close}
          >
            close
          </span>
        </ModalHeader>
        <ModalBody>
          <Spin
            spinning={
              loading ||
              editCafeReservationStatusLoading ||
              startReservationLoading
            }
          >
            {error ||
            editCafeReservationStatusError ||
            startReservationError ? (
              <div className='alert alert-danger'>
                {locales('messages.server.error')}
              </div>
            ) : (
              <div className='container'>
                {/*{failed && <div className='alert alert-danger'>{message}</div>}*/}

                {editCafeReservationStatusFailed && (
                  <div className='alert alert-danger'>
                    {editCafeReservationStatusMessage}
                  </div>
                )}

                {startReservationFailed && (
                  <div className='alert alert-danger'>
                    {startReservationMessage}
                  </div>
                )}

                <div className='row'>
                  <div className='col-12 p-0 py-1'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        {locales('titles.reserveBasicInfo')}
                      </span>
                    </h6>
                  </div>
                  <div className='col-12 d-flex px-1 flex-wrap align-items-right'>
                    <div className='col-12 d-flex px-1 my-2'>
                      <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('tables.requestor')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {createdFullName}
                        </div>
                      </div>
                      <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('phone.number')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {createdUserMobileNumber}
                        </div>
                      </div>
                    </div>
                    <div className='col-12 d-flex px-1 my-2'>
                      <div className='col-6 d-flex align-items-right p-0'>
                        <div className='col-5 text-muted text-right'>
                          {locales('fields.createdAt')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {createdAt}
                        </div>
                      </div>
                      <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('fields.trackingNumber')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large direction-ltr'>
                          {trackingNumber}
                        </div>
                      </div>
                    </div>
                    <div className='col-12 d-flex my-2'>
                      <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('tables.status')} :
                        </div>
                        <div className='col-7  text-dark font-weight-bold font-large p-0 m-0'>
                          {status &&
                            status.length &&
                            enumHelper.convertEnumValueToTitle(
                              ENUMS.CAFE_RESERVATION.list,
                              status,
                            )}
                        </div>
                      </div>
                      <div className='col-6 d-flex align-items-right'>
                        {status === CLIENT_DO_NOT_CAME && (
                          <>
                            <div className='col-5 text-muted text-right'>
                              {locales('clientDoNotComeReason')} :
                            </div>
                            <div className='col-7 text-dark font-weight-bold font-large p-0 m-0'>
                              {reservationDetails.clientReason !== 'OTHER'
                                ? enumHelper.convertEnumValueToTitle(
                                    ENUMS.INCOMMING_RESERVE.clientReason,
                                    reservationDetails.clientReason,
                                  )
                                : reservationDetails.clientOtherReasons}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='col-12 p-0 py-1'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        {locales('titles.reserve.details')}
                      </span>
                    </h6>
                  </div>
                  <div className='col-12 d-flex px-1 flex-wrap align-items-right'>
                    <div className='col-12 d-flex  px-1 my-2'>
                      <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('fields.reserve.start.date')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {startAt}
                        </div>
                      </div>
                      <div className='col-6 d-flex align-items-right p-0'>
                        <div className='col-5 text-muted text-right'>
                          {locales('fields.reserve.end.date')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {endAt}
                        </div>
                      </div>
                    </div>
                    <div className='col-12 d-flex px-1 my-2'>
                      <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('tables.peopleCount')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {persons + ' ' + locales('labels.person.unit')}
                        </div>
                      </div>
                      <div className='col-6 d-flex align-items-right p-0'>
                        <div className='col-5 text-muted text-right'>
                          {locales('tables.mealPortions')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {meal &&
                            meal.length &&
                            enumHelper.convertEnumValueToTitle(
                              ENUMS.MEAL_PORTIONS.list,
                              meal,
                            )}
                        </div>
                      </div>
                    </div>
                    <div className='col-12 d-flex  px-1 my-2'>
                      {/* <div className='col-6 d-flex align-items-right p-0'>
                        <div className='col-5 text-muted text-right'>
                          {locales('tables.reservationType')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {reserveType &&
                            reserveType.length &&
                            enumHelper.convertEnumValueToTitle(
                              ENUMS.RESERVATION_TYPES.list,
                              reserveType,
                            )}
                        </div>
                      </div> */}
                      {/* <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('messages.tables')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {reservedTables &&
                            reservedTables.length &&
                            reservedTables.map(
                              (ele, index, self) =>
                                ` ${ele.num} ${index < self.length - 1 ? '،' : ''
                                }`,
                            )}
                        </div>
                      </div> */}
                    </div>
                    <div className='col-12 d-flex  px-1 my-2'>
                      <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('tables.respondedAt')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {respondedAt}
                        </div>
                      </div>
                      <div className='col-6 d-flex align-items-right p-0'>
                        <div className='col-5 text-muted text-right'>
                          {locales('tables.respondedFullName')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {respondedFullName}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='col-12 p-0 py-1'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        {locales('title.financial.informations')}
                      </span>
                    </h6>
                  </div>
                  <div className='col-12 d-flex px-1 flex-wrap align-items-right'>
                    <div className='col-12 d-flex px-1 my-2'>
                      <div className='col-4 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('prePaid.amount')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {formatter.numberWithCommas(cafeBasePrice) +
                            ' ' +
                            locales('labels.toman')}
                        </div>
                      </div>
                      <div className='col-4 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('entrance.amount')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {formatter.numberWithCommas(totalEntranceAmount) +
                            ' ' +
                            locales('labels.toman')}
                        </div>
                      </div>
                      <div className='col-4 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('title.reservation.fee')} :
                        </div>
                        <div className='col-7 text-dark font-weight-bold font-large'>
                          {formatter.numberWithCommas(reservationFee) +
                            ' ' +
                            locales('labels.toman')}
                        </div>
                      </div>
                    </div>
                    <div className='col-12 d-flex px-1 my-2'>
                      <div className='col-6 d-flex align-items-right'>
                        <div className='col-5 text-muted text-right'>
                          {locales('total.online.paid')} :
                        </div>
                        <div className='col-7 text-danger font-weight-bold font-large'>
                          {formatter.numberWithCommas(baseCost) +
                            ' ' +
                            locales('labels.toman')}
                        </div>
                      </div>
                      <div className='col-12 d-flex px-1 my-2'>
                        <div className='col-6 d-flex align-items-right'>
                          <div className='col-5 text-muted text-right'>
                            {locales('titles.cafeDiscount')} :
                          </div>
                          {cafeDiscountDetailsCopy.discountValue && (
                            <div className='col-7 text-danger font-weight-bold font-large'>
                              %{cafeDiscountDetailsCopy.discountValue}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <InvoiceItems invoiceItems={menuItems} /> */}

                  <div className='col-12 p-0 py-1'>
                    <h6 className='cafes-line-container text-primary'>
                      <span className='line'>
                        {locales('titles.tablesInfo')}
                      </span>
                    </h6>
                  </div>
                  <div
                    className={`col-12 d-flex px-1 flex-wrap align-items-right`}
                  >
                    <table className='table'>
                      <thead>
                        <tr>
                          <th className='text-center'>
                            {locales('tables.tableNumber')}
                          </th>
                          <th className='text-center'>
                            {locales('tables.startTime')}
                          </th>
                          <th className='text-center'>
                            {locales('tables.endTime')}
                          </th>
                          <th className='text-center'>
                            {locales('tables.totalChairs')}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reservedTables &&
                          reservedTables.length &&
                          reservedTables.map(x => (
                            <tr key={x.num}>
                              <td className='text-center'>{x.num}</td>
                              <td className='text-center'>
                                {x.hours.fromTime}
                              </td>
                              <td className='text-center'>{x.hours.toTime}</td>
                              <td className='text-center'>{x.totalChairs}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  {description !== null && description !== '' && (
                    <>
                      <div className='col-12 p-0 py-1'>
                        <h6 className='cafes-line-container text-primary'>
                          <span className='line'>
                            {locales('messages.description')}
                          </span>
                        </h6>
                      </div>
                      <div
                        className={`col-12 d-flex px-1 flex-wrap align-items-right`}
                      >
                        {description}
                      </div>
                    </>
                  )}

                  {permissionHelper.hasUserPermission(
                    ENUMS.PERMISSIONS.values.EDIT_STATUS_RESERVE,
                  ) &&
                    status === WAITING && (
                      <div className='col-12 d-flex flex-wrap justify-content-start align-items-start'>
                        <div className='col-12 p-0 pt-2 pb-1 font-weight-bold text-dark'>
                          <label
                            className=''
                            htmlFor='prePayForEachPersonPerHout'
                          >
                            {locales(
                              'titles.IfTheReservationIsRejectedWriteYourReasonHere',
                            )}{' '}
                            :
                          </label>
                        </div>
                        <div className='col-12 required'>
                          <div className='input-group mb-2'>
                            <textarea
                              name='prePayForEachPersonPerHout'
                              id='prePayForEachPersonPerHout'
                              onChange={handleWriteReasonReserve}
                              rows={4}
                              value={rejectText}
                              type='text'
                              className={`form-control textarea-reject-reserve ${errorClass}`}
                            />
                            <div className={`invalid-feedback`}>
                              {locales('errors.messageBodyRequired')}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )}
          </Spin>
        </ModalBody>
        <ModalFooter>
          {renderButtons()}

          <button
            className='btn btn-light mx-1'
            onClick={close}
            disabled={loading}
          >
            {locales('labels.close.modal')}
          </button>
        </ModalFooter>
      </Modal>
      <ConfirmationModal
        isModalVisible={confirmationModalVisible}
        title={confirmationModalTitle}
        content={confirmationModalContent}
        onOkBtn={isStartReserveBtnClicked ? startReserve : clientDoNotCome}
        onCancelBtn={() => setConfirmationModalVisible(false)}
      />
    </>
  );
}

function mapStateToProps(state) {
  return {
    reservationDetails: state.reservationsReducer.cafeReservationDetails,
    loading: state.reservationsReducer.cafeReservationDetailsLoading,
    message: state.reservationsReducer.cafeReservationDetailsMessage,
    failed: state.reservationsReducer.cafeReservationDetailsFailed,
    error: state.reservationsReducer.cafeReservationDetailsError,

    editCafeReservationStatusLoading:
      state.reservationsReducer.editCafeReservationStatusLoading,
    editCafeReservationStatusFailed:
      state.reservationsReducer.editCafeReservationStatusFailed,
    editCafeReservationStatusError:
      state.reservationsReducer.editCafeReservationStatusError,
    editCafeReservationStatusMessage:
      state.reservationsReducer.editCafeReservationStatusMessage,

    startReservationLoading: state.reservationsReducer.startReservationLoading,
    startReservationFailed: state.reservationsReducer.startReservationFailed,
    startReservationError: state.reservationsReducer.startReservationError,
    startReservationMessage: state.reservationsReducer.startReservationMessage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      getReserveDetails: id =>
        dispatch(reservationActions.fetchReservationDetails(id)),
      startReserve: id => dispatch(reservationActions.startReservation(id)),
      editReserveStatus: (params, status) =>
        dispatch(reservationActions.editReserveStatus(params, status)),
      // clientReason: ({ id, clientReason, otherClientReasons }) =>
      //   dispatch(reservationActions.clientReason({ id, clientReason, otherClientReasons }))
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ReserveDetails);
